/* nimbus-motion-tokens.js
 * Single source of truth for GSAP timing, easing, stagger, and offset values.
 * Exposed on window.NimbusMotion.tokens — must load before nimbus-motion.js.
 */
(function () {
  'use strict';

  window.NimbusMotion = window.NimbusMotion || {};

  window.NimbusMotion.tokens = {
    duration: {
      fast:    0.25,
      base:    0.6,
      slow:    0.9,
      glacial: 1.4
    },

    ease: {
      ease:     'power3.out',
      easeSoft: 'power2.out',
      easeIn:   'power2.in',
      easeEmph: 'expo.out'
    },

    stagger: {
      tight: 0.04,
      base:  0.08,
      loose: 0.14
    },

    offset: {
      sm: 12,
      md: 24,
      lg: 48
    }
  };
})();
